import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, role }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-avx-bg" data-testid="protected-loading">
                <div className="label-mono animate-pulse-soft">Loading…</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }
    if (role && user.role !== role) {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
}
